<div class="container">
  <div class="actions">
    <button class="btn-action" type="button" (click)="openGenerateModal()">
      <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
      Generate API Key
    </button>
  </div>
  <div class="container-table">
    <header class="top-header">
      <h3>API Keys</h3>
      <p>Manage webhook API keys for technology partner integrations.</p>
    </header>

    <!-- <div class="actions">
      <button class="btn-action" type="button" (click)="openGenerateModal()">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Generate API Key
      </button>
    </div> -->

    <!-- <div class="tab-head">
      <div class="search-panel">
        <label for="apiKeySearch">Search</label>
        <div class="search-input-group">
          <input id="apiKeySearch" type="text" placeholder="Search by provider or organization" [(ngModel)]="searchText"
            (keyup.enter)="onSearch()" />
          <select [(ngModel)]="providerFilter" (change)="onSearch()">
            <option value="">All Providers</option>
            <option *ngFor="let provider of providers" [value]="provider.id">{{ provider.label }}</option>
          </select>
          <select [(ngModel)]="organizationFilter" (change)="onSearch()">
            <option value="">All Organizations</option>
            <option *ngFor="let organization of organizations" [value]="organization.id">{{ organization.label }}
            </option>
          </select>
          <button class="btn-action" type="button" (click)="onSearch()">
            <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
            Search
          </button>
          <button class="btn-action ghost-action" type="button" (click)="clearSearch()">
            Clear
          </button>
        </div>
      </div>
    </div> -->
    <div class="table-filters">
      <div class="filter-field">
        <!-- <label for="apiKeySearch">Search</label> -->
        <input id="apiKeySearch"  type="text" placeholder="Search by technology partner or organization" [(ngModel)]="searchText"
            (keyup.enter)="onSearch()" />
      </div>
      <div class="filter-field">
        <!-- <label>Providers</label> -->
        <select [(ngModel)]="providerFilter" (change)="onSearch()">
            <option value="">All Technology Partners</option>
            <option *ngFor="let provider of providers" [value]="provider.id">{{ provider.label }}</option>
          </select>
      </div>
      <div class="filter-field">
        <!-- <label>Billing</label> -->
        <select [(ngModel)]="organizationFilter" (change)="onSearch()">
            <option value="">All Organizations</option>
            <option *ngFor="let organization of organizations" [value]="organization.id">{{ organization.label }}
            </option>
          </select>
      </div>
    </div>

    <div class="search-input-group table-filter-actions">
      <button class="btn-action" type="button" (click)="onSearch()">
        <fa-icon [icon]="['fas', 'magnifying-glass']"></fa-icon>
        Apply Filters
      </button>
      <button class="btn-action ghost-action filter-reset-btn" type="button" (click)="resetFilters()">
        Reset
      </button>
    </div>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Technology Partner</th>
            <th>Organization</th>
            <th>Key Prefix</th>
            <th>Status</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="loading">
            <td colspan="7">Loading API keys...</td>
          </tr>
          <tr *ngFor="let apiKey of apiKeys; let i = index">
            <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td>
            <td>{{ apiKey.provider_name }}</td>
            <td>{{ apiKey.organization_name }}</td>
            <td>{{ maskedKeyPrefix(apiKey.key_prefix) }}</td>
            <td>
              <span class="status-pill" [class.active]="apiKey.is_active" [class.inactive]="!apiKey.is_active">
                {{ apiKey.is_active ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td>{{ apiKey.created_at | date: 'dd/MM/yyyy, h:mm a' }}</td>
            <td>
              <label class="toggle-switch" [title]="apiKey.is_active ? 'Disable' : 'Enable'">
                <input type="checkbox" [checked]="apiKey.is_active" (change)="toggleApiKeyStatus(apiKey, $event)"
                  [disabled]="apiKey._toggling" />
                <span class="toggle-slider"></span>
              </label>
            </td>
          </tr>
          <tr *ngIf="!loading && apiKeys.length === 0">
            <td colspan="7">No API keys found.</td>
          </tr>
        </tbody>
      </table>

      <div class="footer">
        <div class="total-records">Total Records: {{ totalRecords }}</div>
          <app-vte-pagination
                  [currentPage]="currentPage"
                  [pageSize]="recordsPerPage"
                  [totalRecords]="totalRecords"
                  [showJumpToPage]="true"
                  (pageChange)="onPageChange($event)"
                  (pageSizeChange)="onPageSizeChange($event)">
          </app-vte-pagination>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showGenerateModal" class="confirmation-modal">
  <div class="modal-content">
    <header class="top-header">
      <h3>Generate API Key</h3>
      <p>Create a new webhook API key for a technology partner and organization.</p>
    </header>

    <form class="form" [formGroup]="apiKeyForm" (ngSubmit)="submitGenerate()">
      <div class="form-row">
        <div class="form-group">
          <label for="provider">Technology Partner <small>*</small></label>
          <select id="provider" formControlName="provider">
            <option value="">Select technology partner</option>
            <option *ngFor="let provider of providers" [value]="provider.id">{{ provider.label }}</option>
          </select>
          <div class="error" *ngIf="apiKeyForm.get('provider')?.invalid && apiKeyForm.get('provider')?.touched">
            <small>Technology partner is required.</small>
          </div>
        </div>

        <div class="form-group">
          <label for="organization">Organization <small>*</small></label>
          <select id="organization" formControlName="organization">
            <option value="">Select organization</option>
            <option *ngFor="let organization of organizations" [value]="organization.id">{{ organization.label }}
            </option>
          </select>
          <div class="error" *ngIf="apiKeyForm.get('organization')?.invalid && apiKeyForm.get('organization')?.touched">
            <small>Organization is required.</small>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group toggle-field">
          <label for="is_active">Status</label>
          <div class="toggle-input">
            <input id="is_active" type="checkbox" formControlName="is_active" />
            <span>{{ apiKeyForm.get('is_active')?.value ? 'Active' : 'Inactive' }}</span>
          </div>
        </div>
      </div>

      <div class="button-row">
        <button class="btn-save" type="submit" [disabled]="saving || loadingOptions">
          <fa-icon [icon]="['fas', 'square-plus']" style="padding-right: 3px;"></fa-icon>
          Generate
        </button>
        <button class="btn-cancel" type="button" (click)="closeGenerateModal()">
          <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
          Close
        </button>
      </div>
    </form>
  </div>
</div>

<div *ngIf="showSuccessModal" class="confirmation-modal">
  <div class="modal-content api-key-modal-content success-modal-content">
    <header class="top-header modal-header">
      <h3>API Key Generated</h3>
      <p>This key will not be shown again. Copy it now.</p>
    </header>

    <div class="generated-key-box">{{ generatedRawKey }}</div>

    <div class="button-row">
        <app-copy-button [value]="generatedRawKey" copyTitle="Copy API key"></app-copy-button>
      <button class="btn-cancel" type="button" (click)="closeSuccessModal()">
        <fa-icon [icon]="['fas', 'square-xmark']" style="padding-right: 3px;"></fa-icon>
        Close
      </button>
    </div>
  </div>
</div>
